import { createContext } from 'react';
import { AuthContextValue } from './types/AuthTypes';

/**
 * AuthContext
 * 
 * React context for accessing authentication state and methods
 */
export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
